
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import BusinessDashboard from '@/pages/BusinessDashboard';
import NotFound from '@/pages/NotFound';

interface BusinessRoutesProps {
  isLoggedIn: boolean;
  userRole: string | null;
}

const BusinessRoutes: React.FC<BusinessRoutesProps> = ({ isLoggedIn, userRole }) => {
  console.log('BusinessRoutes rendering with isLoggedIn:', isLoggedIn, 'userRole:', userRole);
  
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }
  
  return (
    <Routes>
      <Route
        path="dashboard"
        element={isLoggedIn && userRole === 'business' ? <BusinessDashboard /> : <Navigate to="/login" />}
      />
      <Route path="*" element={<Navigate to="dashboard" replace />} />
    </Routes>
  );
};

export default BusinessRoutes;
